import { createClient } from '@connectrpc/connect';
import { KleosService } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/kleos_service_pb';
import { kleosTransport } from '~/services/api/service-transport';

export const kleosPromiseClient = createClient(KleosService, kleosTransport);
